<template>
    <div
        :class="{
            'c-header__search js-header-search': true,
            'is-form-visible': isFormVisible,
            'is-open': isOpen,
        }"
    >
        <div class="c-search">
            <LuigisAutocompleteForm
                ref="autocompleteForm"
                :autocompleteUrl="autocompleteUrl"
                :isFormVisible="isFormVisible"
                :isOpen="isOpen"
                :inputPlaceholder="inputPlaceholder"
                v-model="keyword"
                @show-form="showForm"
                @hide-form="hideForm"
                @searched="setMatches"
            />
        </div>

        <button class="c-btn c-btn--header" @click="showForm">
            <i class="ico ico-shadow-search"><i class="path1"></i><i class="path2"></i></i>
            <span>{{ $t('Autocomplete.Header.label') }}</span>
        </button>
    </div>
</template>

<script>
import { checkResolution } from '../../tools/helpers';
import RshopAutocomplete from "./../../../../vendor/rshop/frontend/assets/js/components/Autocomplete";
import { showHeaderOverlay, hideHeaderOverlay } from '../../tools/overlay';
import LuigisAutocompleteForm from './LuigisAutocompleteForm';

function loadExternalScript(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.async = true;
        script.src = url;
        script.addEventListener('load', resolve);
        script.addEventListener('error', () => reject('Error loading script.'));
        script.addEventListener('abort', () => reject('Script loading aborted.'));
        document.head.appendChild(script);
    });
}

export default {
    extends: RshopAutocomplete,
    props: {
        luigisBoxPublicKey: {
            type: String,
            required: true,
        },
        texts: {
            type: Object,
            required: true,
        },
    },
    components: {
        LuigisAutocompleteForm: LuigisAutocompleteForm,
    },
    data() {
        return {
            isFormVisible: false,
            luigisBoxInstance: null,
        };
    },
    mounted() {
        loadExternalScript('https://cdn.luigisbox.com/autocomplete.js')
            .then(() => {
                this.initLuigisBox();
            })
            .catch((err) => {
                console.error(err);
            });
    },
    computed: {
        inputPlaceholder() {
            return checkResolution('cxs') ? this.$t('Autocomplete.Header.placeholderMobile') : this.$t('Autocomplete.Header.placeholder')
        }
    },
    methods: {
        initLuigisBox() {
            const vueThis = this
            const luigisBoxInstance = AutoComplete({
                Layout: 'heromobile',
                TrackerId: this.luigisBoxPublicKey,
                Locale: 'sk',
                Translations: {
                    sk: {
                        placeholderText: this.texts.placeholder,
                        types: {
                            product: {
                                name: this.texts.product,
                                heroName: this.texts.topProduct,
                                recommendName: this.texts.recommendProduct,
                                recommendHeroName: this.texts.recommendTopProduct,
                            },
                            promotion: {
                                name: this.texts.promotion,
                                recommendName: this.texts.recommendedPromotion,
                            },
                            category: {
                                name: this.texts.category,
                                recommendName: this.texts.recommendedCategory,
                            },
                            manufacturer: {
                                name: this.texts.manufacturer,
                                recommendName: this.texts.recommendedManufacturer,
                            },
                            brand: {
                                name: this.texts.brand,
                                recommendName: this.texts.recommendedBrand,
                            },
                            article: {
                                name: this.texts.article,
                                recommendName: this.texts.recommendedArticle,
                            },
                        },
                    }
                },
                Types: [
                    {
                        type: 'product',
                        size: 7,
                        attributes: ['custom_contents', 'custom_ribbon_text'],
                        recommend: {
                            size: 7
                        }
                    },
                    {
                        type: 'promotion',
                        size: 6,
                        recommend: {
                            size: 6
                        }
                    },
                    {
                        type: 'category',
                        size: 6,
                        recommend: {
                            size: 6
                        }
                    },
                    {
                        type: 'manufacturer',
                        size: 6,
                        recommend: {
                            size: 6
                        }
                    },
                    {
                        type: 'brand',
                        size: 6,
                        recommend: {
                            size: 6
                        }
                    },
                    {
                        type: 'article',
                        size: 6,
                        recommend: {
                            size: 6
                        }
                    },
                ],
                FormatForDisplay(result) {
                    if (!Eshop.options.pricesWithVat) return result

                    if (result.type === 'product') {
                        result.attributes.price = result.attributes.price_vat
                        result.attributes.price_amount = result.attributes.price_amount_vat

                        if (result.attributes.price_old_vat) {
                            result.attributes.price_old = result.attributes.price_old_vat
                            result.attributes.price_old_amount = result.attributes.price_old_vat_amount
                        }

                        if (result.attributes.custom_ribbon_text == "Zľava" && result.attributes.discount_price_vat_percentage_amount > 0) {
                            result.attributes.custom_ribbon_text = `-${Math.round(result.attributes.discount_price_vat_percentage_amount)}%`
                        }

                    }

                    return result;
                },
                Actions: [
                    {
                        forRow: function(row) {
                            if (row.type !== 'product') {
                                return false;
                            }

                            return row.attributes.availability !== 0;
                        },
                        iconUrl: '/img/icons/cart.svg',
                        title: 'Do košíka',
                        action: function(e, result) {
                            e.preventDefault();

                            $.post(`${Eshop.options.baseUrl}add-item/${result.attributes.id[0]}`, function (response) {
                                Cart.callbacks.addedItem(null, response);
                                rEvent.dispatch('Cart.product.after_add', response);
                            }.bind(this), 'json');
                        }
                    }
                ],
                BeforeOpen() {
                    if (vueThis.isFormVisible) {
                        return
                    }

                    vueThis.showForm()
                },
                AfterClose() {
                    const searchInputEl = vueThis.$refs.autocompleteForm.$refs.searchInput

                    if (document.activeElement !== searchInputEl) {
                        vueThis.hideForm()
                    }
                },
            }, '.js-search-input')

            this.luigisBoxInstance = luigisBoxInstance[0]
        },
        showForm() {
            this.isFormVisible = true
        },
        hideForm() {
            if (this?.luigisBoxInstance?.$IsOpen) {
                this.luigisBoxInstance.Close()
            }

            this.isFormVisible = false
        },
        handleClickOutside($event) {
            if (
                !this.$el.contains($event.target)
                && !$event.target.closest('.swal2-container')
                && !$event.target.closest('.notify')
                && !$event.target.closest('.luigi-ac')
                && !$event.target.closest('[data-tippy-root]')
                && (this.isOpen && this.isFormVisible)
            ) {
                this.isOpen = false;
                this.isFormVisible = false;
                this.selectedIndex = -1;

                this.$el.dispatchEvent(new CustomEvent("autocompleteHide"));

                if (typeof window.rEvent.dispatch === 'function') {
                    window.rEvent.dispatch("Autocomplete.hide");
                }
            }
        },
    },
    watch: {
        isFormVisible(value) {
            const navigationEl = document.querySelector('.js-navigation')

            if (navigationEl) {
                navigationEl.classList.toggle('is-autocomplete-visible', value)
            }

            if (value) {
                showHeaderOverlay('autocomplete')
            } else {
                hideHeaderOverlay('autocomplete')
            }
        }
    }
};
</script>
